
import {INTEGRATIONS_META} from 'consts/integrations.js'
import {Later} from 'utils/timers'

export default {
  props: {
    type: {
      type: String, 
      required: true
    }
  },
  data(){
    return {
      int: undefined,
      timer: 10,
      later: new Later(1000)
    }
  },
  async mounted() {
    this.int = INTEGRATIONS_META[this.type] || {}
    await this.$nextTick()
    this.later.repeat(this.tick)
  },
  methods: {
    tick(){
      this.timer--
      if (this.timer === 0) this.onClose()
    },
    onClose(){
      this.later.abort()
      window.close()
    }
  }
}
